export default __webpack_public_path__ + "0da5a7ebb4e3c9b51420a6a7e171354f.png";